"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isType;
var _definitions = require("../definitions");
function isType(nodeType, targetType) {
  if (nodeType === targetType) return true;

  if (_definitions.ALIAS_KEYS[targetType]) return false;
  const aliases = _definitions.FLIPPED_ALIAS_KEYS[targetType];
  if (aliases) {
    if (aliases[0] === nodeType) return true;
    for (const alias of aliases) {
      if (nodeType === alias) return true;
    }
  }
  return false;
}

//# sourceMappingURL=isType.js.map
